<template>
  <svg
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.15234"
      y="3.26953"
      width="1.06163"
      height="7.39258"
      rx="0.530815"
      transform="rotate(45 6.15234 3.26953)"
      :fill="clr ? clr : '#131111'"
    />
    <rect
      x="13.4004"
      y="0.753906"
      width="1.06163"
      height="9.8364"
      rx="0.530815"
      transform="rotate(40.4208 13.4004 0.753906)"
      :fill="clr ? clr : '#131111'"
    />
    <rect
      x="13.8965"
      y="0.890625"
      width="3.64906"
      height="1.06158"
      rx="0.53079"
      transform="rotate(80.3941 13.8965 0.890625)"
      :fill="clr ? clr : '#131111'"
    />
    <rect
      x="9.87891"
      y="1.31445"
      width="4.07769"
      height="1.06158"
      rx="0.53079"
      transform="rotate(-5.4905 9.87891 1.31445)"
      :fill="clr ? clr : '#131111'"
    />
    <rect
      x="6.56836"
      y="3.27734"
      width="5.59683"
      height="1.06163"
      rx="0.530815"
      transform="rotate(71.2009 6.56836 3.27734)"
      :fill="clr ? clr : '#131111'"
    />
  </svg>
</template>

<script>
export default {
  props: ["clr"]
};
</script>

<style lang="scss" scoped></style>
